/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['confirm-modal.modal .modal-content>.modal-header{margin-bottom:10px}confirm-modal.modal .modal-content>.buttons{margin-top:0}confirm-modal.modal .modal-content>.confirm-content{padding-bottom:15px}confirm-modal.modal .modal-content>.confirm-content>.bold{font-weight:500}confirm-modal.modal .modal-content>.confirm-content>p{font-size:1.5rem}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvbW9kYWwvY29uZmlybS1tb2RhbC9jb25maXJtLW1vZGFsLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9tb2RhbC9jb25maXJtLW1vZGFsL2NvbmZpcm0tbW9kYWwuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/modal/confirm-modal/confirm-modal.component.scss.ngstyle.ts